import React from 'react';
import { ErrorPageTemplate } from 'components/templates/ErrorPageTemplate';
import { EErrorPageType } from 'models/errorPage';

export const ServerErrorPage = () => <ErrorPageTemplate type={EErrorPageType.ServerError} />;
